import React from 'react';
import { Text, StyleSheet, Platform } from 'react-native';
import type { StyleProp, TextStyle } from 'react-native';
import { useEventStore } from 'src/domain/stores/useEventStore';
import Fonts from 'src/core/utils/Fonts';
import Dimens from 'src/core/utils/Dimens';
import Colors from 'src/core/utils/Colors';

interface TitleProps {
	text: string;
	color?: string;
	style?: StyleProp<TextStyle>;
}

export default function Title({ text, color, style }: TitleProps) {
	const resolvedColor = color ?? useEventStore.getState().activeTheme.heading_text_color;

	return <Text style={[styles.heading, { color: resolvedColor }, style]}>{text}</Text>;
}

const styles = StyleSheet.create({
	heading: {
		color: Platform.OS === 'android' ? Colors.blackPure : Colors.greyHeader,
		fontSize: Platform.OS === 'android' ? Dimens.fontSize14 : Dimens.fontSize20,
		paddingLeft: Platform.OS === 'android' ? Dimens.padding16 : Dimens.padding20,
		paddingRight: Platform.OS === 'android' ? Dimens.padding16 : Dimens.padding20,
		marginTop: Platform.OS === 'android' ? Dimens.margin20 : Dimens.margin20,
		marginBottom: Platform.OS === 'android' ? Dimens.margin20 : Dimens.margin20,
		fontFamily: Platform.OS === 'android' ? Fonts.montserratMedium : Fonts.montserratMedium,
		opacity: Platform.OS === 'android' ? 0.54 : undefined,
	},
});
